import { render, staticRenderFns } from "./BaseChipsCard.vue?vue&type=template&id=51433fae&scoped=true&"
import script from "./BaseChipsCard.vue?vue&type=script&lang=js&"
export * from "./BaseChipsCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseChipsCard.vue?vue&type=style&index=0&id=51433fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51433fae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VChip,VIcon})
